import { render } from "./NewProductGroupView.vue?vue&type=template&id=eb63591e"
import script from "./NewProductGroupView.vue?vue&type=script&lang=js"
export * from "./NewProductGroupView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__